import axios from 'axios';
import router from '../router';
import { Message, Loading } from 'element-ui';
let baseURL = process.env.VUE_APP_HOST;//eslint-disable-line
const request = axios.create({
  baseURL: baseURL,
  timeout: 60000,
  headers: {
    'content-type': 'application/json',
  },
});
let requestCount = 0;
let loading;
// 请求拦截器
request.interceptors.request.use(config => { // 拦截请求，做统一处理
  const token = localStorage.getItem('token');
  // 在每个http header都加上token
  config.headers.Authorization = token;
  if (config.method !== 'get') {
    config.data = config.data || {};
  }
  if (!config.stopDefaultLoading) {
    if (requestCount === 0) {
      loading = Loading.service({
        lock: true,
        text: '加载中...',
        spinner: 'el-icon-loading',
      });
    }
    requestCount++;
  }
  return config;
}, err => { // 失败
  return Promise.reject(err);
});
// 响应拦截器
request.interceptors.response.use(response => { // 拦截响应，做统一处理
  if (!response.config.stopDefaultLoading) {
    requestCount--;
    if (requestCount === 0) {
      loading.close();
    }
  }

  if (response.config?.responseType === 'blob') {
    return { data: response.data, headers: response.headers };
  } else if (response.data.repCode && response.data.repCode === '0000' && response.data.success) {
    // 滑动验证码成功
    return response.data;
  } else if (response.data.repCode && response.data.repCode !== '0000' && !response.data.success) {
    // 滑动验证码失败
    Message({
      showClose: true,
      message: response.data.repMsg,
      type: 'error',
    });
    return response.data;
  } else if (response.data.heads && response.data.heads.code === 200) {
    return response.data;
  } else if (response.data.heads && response.data.heads.code === 301) {
    return response.data;
  } else if (response.data.heads && response.data.heads.code === 506) {
    localStorage.clear();
    router.push('/login');
    return Promise.reject(new Error('token已过期'));
  } else {
    if (!response.config.stopDefaultMessage) {
      Message({
        showClose: true,
        message: response.data.heads.message,
        type: 'error',
      });
    }
    return Promise.reject(response.data.heads.message);
  }
}, err => { // 无响应时的处理
  requestCount--;
  if (requestCount === 0) {
    loading.close();
  }
  let defaultMsg = '系统开了小差，请稍后再试';
  if (err.response && err.response.data && err.response.data.heads) {
    defaultMsg = err.response.data.heads.message || defaultMsg;
  }
  Message({
    showClose: true,
    message: defaultMsg,
    type: 'error',
  });
  return Promise.reject((err && err.response && err.response.status) || defaultMsg);
});
export default request;
